// Nova admissão: pessoa + contato + primeiro vínculo, gravados juntos. Se o CPF já existe (ex.:
// ex-estagiário voltando como CLT), oferece abrir o cadastro para incluir um novo vínculo.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Save } from "lucide-react";
import { getRhOpcoes, postRhAdmissao } from "../../api";
import { AvisoErro, btnStyle, palette } from "../estoque/ui";
import RhLayout from "./RhLayout";
import {
  FormContato, FormContrato, FormPessoa, Secao, contatoParaApi, contatoParaForm, contratoParaApi, contratoParaForm,
  pessoaParaApi, pessoaParaForm,
} from "./formularios";

export default function AdmissaoView() {
  const [isLight, setIsLight] = useState(true);
  const C = palette(isLight);
  const navigate = useNavigate();
  const [opcoes, setOpcoes] = useState(null);
  const [pessoa, setPessoa] = useState(pessoaParaForm());
  const [contato, setContato] = useState(contatoParaForm());
  const [contrato, setContrato] = useState(contratoParaForm());
  const [erro, setErro] = useState("");
  const [cpfExistente, setCpfExistente] = useState(null);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    getRhOpcoes().then(setOpcoes).catch((e) => setErro(e.message));
  }, []);

  async function salvar() {
    setErro("");
    setCpfExistente(null);
    if (!pessoa.nome.trim() || !pessoa.cpf || !contrato.tipo_contratacao || !contrato.data_admissao) {
      setErro("Preencha nome, CPF, tipo de contratação e data de admissão.");
      return;
    }
    setSalvando(true);
    try {
      const r = await postRhAdmissao({ pessoa: pessoaParaApi(pessoa), contato: contatoParaApi(contato), contrato: contratoParaApi(contrato) });
      navigate(`/rh/colaboradores/${r.pessoa.id}`);
    } catch (e) {
      if (e.data?.colaborador_id) {
        setCpfExistente(e.data.colaborador_id);
        setErro("Este CPF já está cadastrado.");
      } else {
        setErro(e.message);
      }
    } finally {
      setSalvando(false);
    }
  }

  return (
    <RhLayout titulo="Nova admissão" isLight={isLight} setIsLight={setIsLight}>
      <div style={{ maxWidth: 1100 }}>
        {/* Só renderiza com mensagem: com dois filhos, o AvisoErro recebe ["", null] (truthy) e mostra a barra vazia */}
        {erro && (
          <AvisoErro C={C} onClose={() => { setErro(""); setCpfExistente(null); }}>
            {erro}
            {cpfExistente && (
              <button onClick={() => navigate(`/rh/colaboradores/${cpfExistente}`)} style={{ marginLeft: 8, background: "none", border: "none", color: C.brand, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", textDecoration: "underline" }}>
                Abrir cadastro e incluir novo vínculo
              </button>
            )}
          </AvisoErro>
        )}

        {!opcoes ? (
          <div style={{ color: C.muted, fontSize: 13 }}>Carregando…</div>
        ) : (
          <>
            <Secao C={C} titulo="Dados pessoais"><FormPessoa C={C} form={pessoa} setForm={setPessoa} /></Secao>
            <Secao C={C} titulo="Contato e endereço"><FormContato C={C} form={contato} setForm={setContato} /></Secao>
            <Secao C={C} titulo="Vínculo" descricao="Contrato, remuneração e benefícios">
              <FormContrato C={C} form={contrato} setForm={setContrato} opcoes={opcoes} />
            </Secao>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 24 }}>
              <button onClick={() => navigate("/rh/colaboradores")} style={btnStyle(C.muted, true)}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{ ...btnStyle(C.brand), opacity: salvando ? 0.6 : 1 }}>
                <Save size={15} /> {salvando ? "Salvando…" : "Cadastrar"}
              </button>
            </div>
          </>
        )}
      </div>
    </RhLayout>
  );
}
